import { composeFieldPath } from '@northfork/basics'
import { MvtBasisSelection } from '../../mvt-basis.model'
import { InventoryType } from '../../inventory-type.model'
export const securityExchangeField = composeFieldPath(
  [] as BulkSecurityExchangeRow[],
)

export interface BulkSecurityExchangeRow {
  rowId: string
  rowNumber?: string
  accountId: string
  entryDate: string
  fromAssetId: string
  toAssetId: string
  fromUnits: string
  toUnits: string
  rate: string
  marketPrice: string
  inventoryType: string
  exchangeType: string
  isConversion: string
  mvtBasisSelection: MvtBasisSelection[]
  mvtBasisSelectionText: string
  validityStatus: 'valid' | 'invalid' | 'warning' | 'inactive' | 'intermediate'
  errorMessageMap: Map<string, string[]>
  legacyOrigTranId?: number
  collateralBroker?: string
  securityId?: number
  balanceUnits?: number
  calcTransferPrice?: number
  basisId?: number
}

export interface BulkSecurityExchangeDerivedRequest {
  rowId: number
  accountId: number
  entryDate: string
  inventoryType?: string
  fromCusip?: string
  toCusip?: string
  fromUnits?: number
  toUnits?: number
  rate?: number
  transferPrice?: number
}

export interface BulkSecurityExchangeDetailsRequest {
  exchangeDetailsRequest: BulkSecurityExchangeDerivedRequest[]
}

export interface PricingData {
  price?: number
  securityId?: number
}

export interface BulkSecurityExchangeDerivedResponse {
  tranDetails: { [key: string]: ExchangeDerivedFields }
  securityIdMap: { string: number }
}

export interface ExchangeDerivedFields {
  toUnits?: number
  pricingData: PricingData
  fromUnits?: number
  balanceUnits?: number
  rate?: number
  calcTransferPrice?: number
}
export enum ExchangeType {
  CUSIP_EXCHANGE = 'CUSIP_EXCHANGE',
  CONVERSION = 'CONVERSION',
}
